import AttendeeInputs from "../Sub_components/AttendeeInputs";
import ToggleSwitch from "../Sub_components/ToggleSwitch";
import MobileViewDetail from "../Sub_components/MobileViewDetail";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { memo } from "react";

const ToggleSwitchComponent = ({ toggleLocalVideo, toggleLocalAudio }) => {
  const { role, eventType, filteredPreviewAppointment } =
    useLiveStreamAppContext();

  const newSettings = [
    {
      label: "Record to Vagaro Drive",
      name: "StartRecording",
      key: 1
    },
    {
      label: "Instructor Only Mode",
      key: 2,
      ifInfo: true,
      message:"Attendees can view and hear the instructor, but not other attendees.",
      name: "InstructorMode",
      ifInfoMessage: "This cannot be changed during the live stream session.",
    },
  ];

  return (
    <div className="centerAttendeeWrap">
      <MobileViewDetail
        toggleLocalAudio={toggleLocalAudio}
        toggleLocalVideo={toggleLocalVideo}
      />
      <div className="section-checkboxes input-view-on-mobile">
        <div className="public-screen-name leftAlignSwitch">
          <div className="setting-popup-checkbox">
            {role === "Presenter" ? (
              eventType === 2 ? (
                newSettings.map((item) => (
                  <ToggleSwitch
                    label={item.label}
                    key={item.key}
                    message={item.message}
                    ifInfoMessage={item.ifInfoMessage}
                    name={item.name}
                    ifInfo={item.ifInfo}
                  />
                ))
              ) : (
                filteredPreviewAppointment.map((item, index) => (
                  <ToggleSwitch
                    label={item.label}
                    key={item.key}
                    ifInfoMessage={item.ifInfoMessage}
                    message={item.message}
                    name={item.name}
                  />
                ))
              )
            ) : (
              <AttendeeInputs />
            )}
          </div>
          {eventType === 1 && role === "Presenter" && (
            newSettings
            .filter(item => !(item.name === "InstructorMode" && eventType === 1))
            .map((item, index) => (
              <ToggleSwitch
                label={item.label}
                key={item.key}
                ifInfoMessage={item.ifInfoMessage}
                message={item.message}
                name={item.name}
                ifInfo={item.ifInfo}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};
export default memo(ToggleSwitchComponent);
